/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerListAccountUsersQueryResponse, TrimbleDiagnosticsControllerListAccountUsersPathParams, TrimbleDiagnosticsControllerListAccountUsers400, TrimbleDiagnosticsControllerListAccountUsers401, TrimbleDiagnosticsControllerListAccountUsers403, TrimbleDiagnosticsControllerListAccountUsers404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerListAccountUsers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleDiagnosticsControllerListAccountUsers } from "../../clients/trimble-diagnosticsService/trimbleDiagnosticsControllerListAccountUsers";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleDiagnosticsControllerListAccountUsersQueryKey = (iamAccountId: TrimbleDiagnosticsControllerListAccountUsersPathParams["iamAccountId"]) => [{
  url: '/api/v1/trimble-account-users-diagnostics/:iamAccountId',
  params: {
    iamAccountId: iamAccountId
  }
}] as const;
export type TrimbleDiagnosticsControllerListAccountUsersQueryKey = ReturnType<typeof trimbleDiagnosticsControllerListAccountUsersQueryKey>;
export function trimbleDiagnosticsControllerListAccountUsersQueryOptions(iamAccountId: TrimbleDiagnosticsControllerListAccountUsersPathParams["iamAccountId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleDiagnosticsControllerListAccountUsersQueryKey(iamAccountId);
  return queryOptions<TrimbleDiagnosticsControllerListAccountUsersQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerListAccountUsers400 | TrimbleDiagnosticsControllerListAccountUsers401 | TrimbleDiagnosticsControllerListAccountUsers403 | TrimbleDiagnosticsControllerListAccountUsers404>, TrimbleDiagnosticsControllerListAccountUsersQueryResponse, typeof queryKey>({
    enabled: !!iamAccountId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleDiagnosticsControllerListAccountUsers(iamAccountId, config);
    }
  });
}

/**
 * @summary List the Trimble IAM users in an account
 * {@link /api/v1/trimble-account-users-diagnostics/:iamAccountId}
 */
export function useTrimbleDiagnosticsControllerListAccountUsers<TData = TrimbleDiagnosticsControllerListAccountUsersQueryResponse, TQueryData = TrimbleDiagnosticsControllerListAccountUsersQueryResponse, TQueryKey extends QueryKey = TrimbleDiagnosticsControllerListAccountUsersQueryKey>(iamAccountId: TrimbleDiagnosticsControllerListAccountUsersPathParams["iamAccountId"], options: {
  query?: Partial<QueryObserverOptions<TrimbleDiagnosticsControllerListAccountUsersQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerListAccountUsers400 | TrimbleDiagnosticsControllerListAccountUsers401 | TrimbleDiagnosticsControllerListAccountUsers403 | TrimbleDiagnosticsControllerListAccountUsers404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleDiagnosticsControllerListAccountUsersQueryKey(iamAccountId);
  const query = useQuery({
    ...trimbleDiagnosticsControllerListAccountUsersQueryOptions(iamAccountId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleDiagnosticsControllerListAccountUsers400 | TrimbleDiagnosticsControllerListAccountUsers401 | TrimbleDiagnosticsControllerListAccountUsers403 | TrimbleDiagnosticsControllerListAccountUsers404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}